<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Evidence',
  },
})

const page = {
  groupTitle: 'Dokumen',
  icon: 'ri-attachment-2',
  color: 'info',
  title: 'Melampirkan Bukti (Evidence)',
  description: 'Cara upload, lihat, dan hapus file bukti — dipakai di banyak modul, bukan cuma Dokumen.',
  purpose: 'Menjelaskan komponen unggah file yang sama dipakai berulang di Dokumen, Checklist, IKP, CAPA, Rapat, dan Kredensial Pegawai.',
  concept: [
    {
      icon: 'ri-attachment-2',
      title: 'Satu Komponen, Banyak Tempat',
      text: 'Tombol lampiran file yang Anda lihat di halaman Dokumen, hasil Checklist, IKP, CAPA, Rapat, dan Kredensial Pegawai semuanya komponen yang sama — cara pakainya identik di mana pun Anda menemukannya.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'File Bersifat Privat',
      text: 'File yang Anda upload tidak bisa diakses lewat tautan sembarangan — hanya bisa diunduh oleh orang yang memang berhak melihat data induknya (dokumen/checklist/IKP terkait).',
    },
  ],
  steps: [
    { title: 'Cari area "Lampiran" atau "Evidence" di halaman detail', detail: 'Biasanya berupa kotak drag-and-drop atau tombol "Upload File".' },
    { title: 'Pilih file dari komputer Anda, atau seret ke kotak upload', detail: 'Format yang didukung: PDF, JPG/PNG/WEBP, MP4, XLSX, DOCX.' },
    { title: 'Tunggu proses upload selesai', detail: 'File langsung muncul di daftar lampiran begitu selesai diunggah.' },
    { title: 'Klik ikon mata untuk melihat, ikon sampah untuk menghapus', detail: 'Menghapus lampiran butuh permission terpisah — kalau tombol hapus tidak muncul, berarti akun Anda belum punya akses itu.' },
  ],
  tips: [
    'Ukuran maksimum 10MB untuk dokumen/gambar, 50MB untuk video.',
    'Beri nama file yang jelas sebelum diunggah — nama file asli yang tersimpan di sistem.',
    'Lampiran pada dokumen/checklist yang statusnya sudah final terkadang tidak bisa dihapus lagi — ini disengaja untuk menjaga jejak bukti.',
  ],
  faq: [
    { q: 'Kenapa saya tidak bisa menghapus lampiran yang saya upload sendiri?', a: 'Kalau data induknya (mis. dokumen) sudah berstatus final/terbit, lampirannya ikut terkunci supaya bukti historis tidak hilang — ini bukan bug.' },
    { q: 'Berapa lama file tersimpan?', a: 'Selamanya, selama data induknya tidak dihapus. QUALIVA tidak menghapus lampiran secara otomatis.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
